import { FC } from 'react'
import { Translation } from '@dxp-module/common'
import { Typography } from '@mui/material'
import financeBreakdownTitleStyles from './financeBreakdownTitle.styles'

type FinanceBreakdownTitleProps = {
  title: string
}

const FinanceBreakdownTitle: FC<FinanceBreakdownTitleProps> = ({ title }) => {
  const styles = financeBreakdownTitleStyles()

  return (
    <Typography
      className={styles.mainTitle}
      data-test="summary:finance_breakdown_title"
    >
      <Translation className={styles.mainTitleContent} id={title} />
    </Typography>
  )
}

export default FinanceBreakdownTitle
